import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Credits } from "../../components";
import { ContainersEntity, SlidesEntity } from "../../_entities";

const { fetchAppHome, fetchTicker } = ContainersEntity.actions;
const { fetchSponsors } = SlidesEntity.actions;

const Quick = () => {
  const dispatch = useDispatch();

  const loadHome = useCallback(async () => {
    try {
      dispatch(fetchAppHome());
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const loadSponsors = useCallback(async () => {
    try {
      dispatch(fetchSponsors());
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  useEffect(() => {
    loadHome();
    loadSponsors();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Credits />
    </>
  );
};

export default Quick;
